import { z } from 'zod';
import { asciify } from '@/common/asciify';

const normNameRemoveRegex = /(?:wsdc|registry|registered|event|nasde|cancelled|postponed|edition|official event page| and |\(.*?\)|[0-9]+th|\P{Alphabetic})/ug;

export function normalizeName(name: string): string {
	return asciify(name).replaceAll(normNameRemoveRegex, '');
}

export const ValuesSchema = z.object({
	deleted: z.boolean().optional(),
	sources: z.array(z.string()),
	name: z.string(),
	when: z.union([
		z.object({ sunday: z.string() }),
		z.object({ year: z.string() })
	]),
	cancelled: z.boolean().optional(),
	cover: z.string().optional(),
	facebook: z.record(z.string(), z.object({
		going: z.number().optional(),
		responded: z.number().optional()
	})).optional(),
	links: z.array(z.object({
		kind: z.string(),
		url: z.string(),
		title: z.string().optional()
	})),
	people: z.array(z.string()),
	wsdc: z.boolean().optional(),
	nasde: z.boolean().optional(),
	countryCode: z.string().optional(),
	hotel: z.boolean().optional(),
	venues: z.record(z.string(), z.object({
		name: z.string().optional(),
		address: z.string().optional(),
		url: z.string().optional()
	})).optional(),
	dances: z.array(z.string()).optional(),
	series: z.string().optional()
});

export type Values = z.infer<typeof ValuesSchema>;
